import { __assign, __extends } from "tslib";
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import isArray from 'lodash/isArray';
import { isPaywallSeo, getPaywallSeoClass } from './utils/paywallSeo';
import { sizeClassName, alignmentClassName, textWrapClassName, normalizeUrl, } from 'wix-rich-content-common';
import { getBlockIndex } from './utils/draftUtils';
import { getInteractionWrapper, DefaultInteractionWrapper, } from './utils/getInteractionWrapper';
import { getRangeStyles } from '../styleRenderer';
var PluginViewer = /** @class */ (function (_super) {
    __extends(PluginViewer, _super);
    function PluginViewer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getContainerClassNames = function () {
            var _a;
            var _b = _this.props, pluginComponent = _b.pluginComponent, componentData = _b.componentData, styles = _b.styles, _c = _b.context, theme = _c.theme, isMobile = _c.isMobile;
            var _d = pluginComponent.classNameStrategies || {}, size = _d.size, alignment = _d.alignment, textWrap = _d.textWrap, custom = _d.custom;
            var hasLink = _this.componentHasLink();
            var html = componentData.html;
            return classNames(styles.pluginContainerReadOnly, (_a = {},
                _a[styles.pluginContainerMobile] = isMobile,
                _a[styles.anchor] = hasLink,
                _a[theme.anchor] = hasLink && theme.anchor,
                _a[styles.embed] = hasLink && html,
                _a), isFunction(alignment)
                ? alignment(componentData, theme, styles, isMobile)
                : alignmentClassName(componentData, theme, styles, isMobile), isFunction(size)
                ? size(componentData, theme, styles, isMobile)
                : sizeClassName(componentData, theme, styles, isMobile), isFunction(textWrap)
                ? textWrap(componentData, theme, styles, isMobile)
                : textWrapClassName(componentData, theme, styles, isMobile), isFunction(custom) ? custom(componentData, theme, styles, isMobile) : null);
        };
        _this.componentHasLink = function () {
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.componentData) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.link) === null || _d === void 0 ? void 0 : _d.url;
        };
        return _this;
        /* eslint-enable complexity */
    }
    /* eslint-disable complexity */
    PluginViewer.prototype.render = function () {
        var _a = this.props, id = _a.id, type = _a.type, pluginComponent = _a.pluginComponent, componentData = _a.componentData, children = _a.children, styles = _a.styles, entityIndex = _a.entityIndex, context = _a.context, blockIndex = _a.blockIndex, rangeStyles = _a.rangeStyles;
        var Component = pluginComponent.component, elementType = pluginComponent.elementType;
        var container = (pluginComponent.classNameStrategies || {}).container;
        var anchorTarget = context.anchorTarget, relValue = context.relValue, config = context.config, theme = context.theme;
        var settings = (config === null || config === void 0 ? void 0 : config[type]) || {};
        var componentProps = __assign({ componentData: componentData,
            settings: settings,
            children: children,
            entityIndex: entityIndex }, context);
        if (Component) {
            if (elementType !== 'inline') {
                var _b = componentData.config, componentConfig = _b === void 0 ? {} : _b;
                var hasLink = this.componentHasLink();
                var ContainerElement = hasLink ? 'a' : 'div';
                var containerProps = {};
                if (hasLink) {
                    var _c = componentConfig.link, url = _c.url, target = _c.target, rel = _c.rel;
                    containerProps = {
                        href: normalizeUrl(url),
                        target: target || anchorTarget || '_self',
                        rel: rel || relValue || 'noopener noreferrer',
                    };
                }
                // TODO: more generic logic?
                var customStyles = void 0;
                if (componentConfig.size === 'inline' ||
                    type === 'wix-draft-plugin-html') {
                    customStyles = { width: componentConfig.width };
                }
                if (type === 'wix-draft-plugin-image') {
                    var _d = componentData.src, src = _d === void 0 ? {} : _d;
                    var size = componentConfig.size;
                    if (size === 'original' && src.width) {
                        customStyles = { width: src.width, maxWidth: '100%' };
                    }
                }
                if (customStyles) {
                    containerProps.style = customStyles;
                }
                return (React.createElement("div", { id: id, className: classNames(rangeStyles && rangeStyles.classNames, // DA Edit
                    styles.atomic, isPaywallSeo(context.seoMode) &&
                        getPaywallSeoClass(context.seoMode.paywall, blockIndex)), style: rangeStyles && rangeStyles.styles },
                    React.createElement(ContainerElement, __assign({ className: this.getContainerClassNames() }, containerProps), isFunction(container) ? (React.createElement("div", { className: container(theme) },
                        React.createElement(Component, __assign({}, componentProps)))) : (React.createElement(Component, __assign({}, componentProps))))));
            }
            else {
                // DA Edit
                return (React.createElement(Component, __assign({ className: classNames(rangeStyles && rangeStyles.classNames), style: rangeStyles && rangeStyles.styles }, componentProps)));
            }
        }
        return null;
    };
    return PluginViewer;
}(PureComponent));
// return a list of types with a function that wraps the viewer
var getPluginViewers = function (typeMappers, context, styles, addAnchorFnc) {
    var res = {};
    Object.keys(typeMappers).forEach(function (type, i) {
        res[type] = function (children, entity, _a) {
            var key = _a.key, block = _a.block;
            var pluginComponent = typeMappers[type];
            var isInline = pluginComponent.elementType === 'inline';
            var interactions = entity.interactions;
            var ViewerWrapper = isArray(interactions)
                ? getInteractionWrapper({ interactions: interactions, context: context })
                : DefaultInteractionWrapper;
            var shouldAddAnchor = addAnchorFnc && !isInline;
            return (React.createElement(React.Fragment, { key: i + "_" + key },
                React.createElement(ViewerWrapper, null,
                    React.createElement(PluginViewer, { id: "viewer-" + block.key, type: type, pluginComponent: pluginComponent, componentData: entity, entityIndex: key, context: context, styles: styles, blockIndex: getBlockIndex(context.contentState, block.key), 
                        // DA edit
                        rangeStyles: getRangeStyles(block, key) }, isInline ? children : null)),
                shouldAddAnchor &&
                    addAnchorFnc(type.replace('wix-draft-plugin-', '').toLowerCase())));
        };
    });
    return res;
};
export default getPluginViewers;
//# sourceMappingURL=getPluginViewers.js.map